function Feedback() {
  return (
    <center>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSel6SqAyxd7ZCOgkMNF1z23qAI1UpvA4agpsMH7vc1yrRES4w/viewform?embedded=true"
        width="100%"
        height="1470"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
        title="feedback"
      >
        Loading…
      </iframe>
    </center>
  );
}

export default Feedback;
